export default __webpack_public_path__ + "static/media/bonds.fff74d6c.svg";